<form [formGroup]="agregarFormBonificadorRegalo">
  <input name="id_material_ant" formControlName="id_material_ant" type="hidden" />
  <input name="id_unidad_ant" formControlName="id_unidad_ant" type="hidden" />
  <div class="row mb-3">
    <div class="col-6 col-lg-4">
      <label for="file" class="form-label">Agregar desde csv*</label>
      <input type="file" accept=".csv" class="form-control form-control-sm" id="file" #fileInput (change)="onFileSelect($event)" />
    </div>
  </div>
  <hr />
  <div class="row align-items-center">
    <div class="col-lg-6">
      <app-lfsa-input [control]="this.agregarFormBonificadorRegalo.get('id_promo')" [id]="'id_promo'"
        [isReadOnly]="true" [label]="'ID PROMO'" formControlName="id_promo" type="text"></app-lfsa-input>
    </div>
    <div class="col-lg-6">
      <span class="d-block">{{materialTitle|titlecase}}</span>
      <button class="btn btn-primary col" role="button" data-bs-toggle="modal" data-bs-target="#materialModal">
        <span>Buscar Material</span>
        <i class="fas fa-search"></i>
      </button>
    </div>
    <div class="col-lg-6">
      <label for="id_unidad">Unidad</label>
      <select class="form-control mb-3" formControlName="id_unidad" id="id_unidad">
        <option value="">Seleccione una opción</option>
        <option *ngFor="let data of comboPresentaciones" [value]="data.idUnidad">{{ data.idUnidad }}</option>
      </select>
    </div>
    <div class="col-lg-4">
      <app-lfsa-input [control]="this.agregarFormBonificadorRegalo.get('cantidad1')" [id]="'cantidad1'"
        [isReadOnly]="false" [label]="'Cantidad 1'" formControlName="cantidad1" type="number"></app-lfsa-input>
    </div>
    <div class="col-lg-4">
      <app-lfsa-input [control]="this.agregarFormBonificadorRegalo.get('cantidad2')" [id]="'cantidad2'"
        [isReadOnly]="false" [label]="'Cantidad 2'" formControlName="cantidad2" type="number"></app-lfsa-input>
    </div>
    <div class="col-lg-4">
      <app-lfsa-input [control]="this.agregarFormBonificadorRegalo.get('cantidad3')" [id]="'cantidad3'"
        [isReadOnly]="false" [label]="'Cantidad 3'" formControlName="cantidad3" type="number"></app-lfsa-input>
    </div>
    <div class="col-lg-12">
      <app-lfsa-input [control]="this.agregarFormBonificadorRegalo.get('relacion21')" [id]="'relacion21'"
        [isReadOnly]="false" [label]="'Relacion 2x1'" formControlName="relacion21"
        type="number"></app-lfsa-input>
    </div>
  </div>
  <app-lfsa-botones-formulario (devolverAccion)="accionesBonificadoresRegalo( $event )"
    [formularioValido]="(!agregarFormBonificadorRegalo.invalid) ? false : true"
    [textBoton]="'Guardar'" class="row">
  </app-lfsa-botones-formulario>
</form>
